<script setup>
import { useI18n } from 'vue-i18n';
import LaisField from 'dashboard/components-next/LaisField.vue';
import NucleoWorkOrderServiceDocuments from './NucleoWorkOrderServiceDocuments.vue';

defineProps({
  form: { type: Object, required: true },
  canUpdate: { type: Boolean, default: false },
  canComplete: { type: Boolean, default: false },
  transactionId: { type: [String, Number], default: null },
  parties: { type: Array, default: () => [] },
});
const emit = defineEmits(['change', 'filesSelected', 'documentsUploaded']);
const { t } = useI18n();
const update = (key, event) => emit('change', { [key]: event.target.value });
</script>

<template>
  <div class="grid gap-5">
    <fieldset class="grid gap-3">
      <label
        v-if="canUpdate"
        class="flex items-start gap-3 text-sm text-lais-text"
      >
        <input
          :checked="form.mode === 'update'"
          type="radio"
          value="update"
          class="mt-1"
          @change="update('mode', $event)"
        />
        {{ t('NUCLEO_WORK_ORDERS.DETAIL.EXECUTION.UPDATE') }}
      </label>
      <label
        v-if="canComplete"
        class="flex items-start gap-3 text-sm text-lais-text"
      >
        <input
          :checked="form.mode === 'complete'"
          type="radio"
          value="complete"
          class="mt-1"
          @change="update('mode', $event)"
        />
        {{ t('NUCLEO_WORK_ORDERS.DETAIL.EXECUTION.COMPLETE') }}
      </label>
    </fieldset>
    <LaisField
      v-if="form.mode === 'update'"
      :label="t('NUCLEO_WORK_ORDERS.DETAIL.FIELDS.SCHEDULED_FOR')"
      required
    >
      <input
        :value="form.scheduled_for"
        data-test="execution-scheduled-for"
        type="date"
        class="min-h-10 rounded-lais border border-lais-border bg-white px-3 text-sm"
        @input="update('scheduled_for', $event)"
      />
    </LaisField>
    <LaisField
      v-if="form.mode === 'update'"
      :label="t('NUCLEO_WORK_ORDERS.DETAIL.FIELDS.EVIDENCE')"
      :helper="t('NUCLEO_WORK_ORDERS.DETAIL.FIELDS.EVIDENCE_HELPER')"
    >
      <input
        type="file"
        multiple
        class="text-sm text-lais-text-body"
        @change="emit('filesSelected', $event)"
      />
    </LaisField>
    <NucleoWorkOrderServiceDocuments
      v-if="form.mode === 'update'"
      :transaction-id="transactionId"
      :parties="parties"
      @uploaded="emit('documentsUploaded', $event)"
    />
    <LaisField :label="t('NUCLEO_WORK_ORDERS.DETAIL.FIELDS.OBSERVATION')">
      <textarea
        :value="form.observacao"
        rows="4"
        class="rounded-lais border border-lais-border bg-white px-3 py-2 text-sm"
        @input="update('observacao', $event)"
      />
    </LaisField>
  </div>
</template>
